import classNames from 'classnames';
import { useId } from 'react';

import { paths } from '@farmersdog/constants';
import { Link, Carousel, ResponsiveText } from '@farmersdog/corgi-legacy';
import { PageWidth, Wave } from '@farmersdog/corgi-x';

import styles from './CustomerReviews.css';
import { ReviewCard } from './ReviewCard';
import { reviewsData } from './reviewsData';

export function CustomerReviews() {
  const id = useId();

  return (
    <Wave withBottom withTop>
      <PageWidth>
        <section aria-labelledby={id} className={styles.section}>
          <ResponsiveText
            variant="heading-3"
            color="kale-3"
            as="h2"
            className={styles.center}
            id={id}
          >
            What customers are saying about fresh dog food
          </ResponsiveText>
          <Carousel className={styles.reviews}>
            {reviewsData.map(data => {
              return <ReviewCard key={data.author} {...data} />;
            })}
          </Carousel>
          <Link
            className={classNames(styles.cta, styles.center)}
            asButton
            href={paths.PATH_SIGNUP}
          >
            Feed Fresh Today
          </Link>
        </section>
      </PageWidth>
    </Wave>
  );
}
